$(document).ready(function() {
    var $item = $(".rotatingtextitem");
    $item.hide().eq(0).show();
    var nTotal = $item.length;
    var nPos = 0;
    setInterval(RotateLinks, 1000);
  
    function RotateLinks() {
      $item.eq(nPos).fadeOut(0, function() {
        nPos++;
        if (nPos == nTotal) {
          nPos = 0;
        }
        $item.eq(nPos).fadeIn(0)
      });
    }
  });